import { parseCookie } from "../../payment/miscellaneous/parseCookie";

export function isOrderCookie() {
  const cookieParsed = parseCookie(document.cookie);

  return !!cookieParsed["MkHcOrderId"];
}
